import { FAQs } from 'smooth-doc/components';
import * as React from 'react';
export default {
  FAQs,
  React
};